import React from "react";

const Heading = ({ as: Tag = "h2", content, margin, className = "" }) => {
  return (
    <Tag
      style={{ margin }}
      className={`type-section-title whitespace-normal ${className}`}
    >
      {content}
    </Tag>
  );
};

export default Heading;
